import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, TableFooter } from "@mui/material";
import { InvoiceDetailLineItem } from "../../../utils/types";
import { useEffect } from "react";
import { toast } from "react-toastify";

const ApproverPageTable = ({
  selectedLineItemIds,
  dataApproverList,
  setSelectedLineItemIds,
  totalSelectedAmount,
  procurementType,
}: {
  selectedLineItemIds: { grn_no: string; line_item: string; index: any; batch_ses_no: string, RefDocIt: string, Lfbnr: string }[];
  dataApproverList: any;
  setSelectedLineItemIds: any;
  totalSelectedAmount: number;
  procurementType: string;
}) => {

  const handleCheckboxSelection = (event: any, item: any, index: any, isSelected: any) => {
    var list = [];
    dataApproverList?.invoice_details_table?.forEach((obj: any, index: any) => {
      if ((obj?.grn_no === item?.grn_no)) {
        list.push({ ...obj, index: index });
      }
    });
    setSelectedLineItemIds((prev) => {
      if (event.target.checked) {
        return [
          ...prev,
          ...list
        ];
      } else {
        return prev.filter((id) => (id?.grn_no !== item?.grn_no));
      }
    });

    // isSelected && procurementType === "D" && toast.error("All GRN for selected Batch/SES No. are removed.");
  };
  return (
    <TableContainer component={Paper} sx={{ border: "1px solid #ccc", borderRadius: "8px", maxHeight: "70vh", overflow: "auto" }}>
      <Table stickyHeader aria-label="invoice details table">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox" sx={{ width: 60 }}>
              <Checkbox
                indeterminate={selectedLineItemIds?.length > 0 && selectedLineItemIds?.length < dataApproverList?.invoice_details_table?.length}
                checked={dataApproverList?.invoice_details_table?.length > 0 && selectedLineItemIds?.length === dataApproverList?.invoice_details_table?.length}
                onChange={(event) => {
                  setSelectedLineItemIds(
                    event.target.checked
                      ? dataApproverList?.invoice_details_table?.map((item, index) => {
                        return {
                          grn_no: item?.grn_no,
                          line_item: item?.line_item,
                          batch_ses_no: item?.batch_ses_no,
                          index: index,
                          RefDocIt: item?.RefDocIt,
                          Lfbnr: item?.Lfbnr
                        };
                      })
                      : []
                  );
                }}
              />
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              GRN No.
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 70,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              PO Contract
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 70,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              REF DOC ITEM
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Line Item
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Description
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Invoice Qty.
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Rate
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Tax %
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Batch/SES No.
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              HSN/SAC
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Tax Amount
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 100,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Amount
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Invoice No.
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Tax Code
            </TableCell>
            <TableCell
              align="center"
              sx={{
                minWidth: 50,
                fontSize: "0.75rem",
                fontWeight: "bold",
              }}
            >
              Year
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dataApproverList.invoice_details_table.map((item: InvoiceDetailLineItem, index) => {
            var isSelected = selectedLineItemIds.some(
              (selected) => selected?.grn_no === item?.grn_no && selected?.batch_ses_no === item?.batch_ses_no && selected?.index === index
            );
            if (procurementType === "D") {
              isSelected = selectedLineItemIds.some((selected) => selected?.grn_no === item?.grn_no && selected?.batch_ses_no === item?.batch_ses_no);
            }

            return (
              <TableRow
                key={index}
                selected={isSelected}
                hover
                sx={{
                  "&:nth-of-type(odd)": {
                    backgroundColor: (theme) => theme.palette.action.hover,
                  },
                }}
              >
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isSelected}
                    onChange={(event) => handleCheckboxSelection(event, item, index, isSelected)}
                    inputProps={{
                      "aria-label": `Select item ${index}`,
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item.grn_no || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item.po_no || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item.RefDocIt || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.line_item || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item.description || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.bill_qty || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.rate || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.tax_percentage || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.batch_ses_no || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.hsn_sac || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.tax_amount || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                    {Number(item?.amount)?.toFixed(2) || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.bill_no || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.tax_code || "N/A"}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Typography variant="body2" sx={{ fontSize: "0.75rem" }}>
                    {item?.doc_year || "N/A"}
                  </Typography>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow
            sx={{
              backgroundColor: "#f5f5f5",
              position: "sticky",
              bottom: 0,
              zIndex: 1000,
              boxShadow: "0 -2px 4px rgba(0,0,0,0.1)",
            }}
          >
            <TableCell colSpan={11} align="right" sx={{ fontWeight: "bold", fontSize: "0.875rem" }}>
              Total Selected Amount:
            </TableCell>
            <TableCell
              colSpan={2}
              align="right"
              sx={{
                fontWeight: "bold",
                fontSize: "0.875rem",
                color: "primary.main",
              }}
            >
              ₹ {totalSelectedAmount.toFixed(2)}
            </TableCell>
            <TableCell colSpan={3}></TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default ApproverPageTable;
